__turbopack_context__.v({
  "cards": "style-module-scss-module__qjgnJG__cards",
  "container": "style-module-scss-module__qjgnJG__container",
  "media": "style-module-scss-module__qjgnJG__media",
});
